import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import config from "../config";
import { forceLogout } from "../context/AuthContext";

// ===================================
// 🌐 Configurações Globais do Axios
// ===================================
axios.defaults.baseURL = config.API_URL;
//axios.defaults.headers.post["Content-Type"] = "application/json";

export interface ApiResponse<T> {
  data: T;
  status: number;
}

// ===================================
// 🔥 Interceptor de Resposta
// ===================================
// axios.interceptors.response.use(
//   response => response,
//   (error: AxiosError) => {
//     let message = "Erro desconhecido";

//     switch (error.response?.status) {
//       case 401:
//         message = "Credenciais inválidas";
//         break;
//       case 404:
//         message = "Recurso não encontrado";
//         break;
//       case 500:
//         message = "Erro interno no servidor";
//         break;
//       default:
//         message = error.message || "Falha ao executar requisição";
//     }

//     return Promise.reject(message);
//   }
// );
axios.interceptors.response.use(
  response => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      console.log("Credenciais inválidas - 401");
      forceLogout();
    }

    let message = "Erro desconhecido";

    switch (error.response?.status) {
      case 401:
        message = "Sessão expirada";
        break;
      case 404:
        message = "Recurso não encontrado";
        break;
      case 500:
        message = "Erro interno no servidor";
        break;
      default:
        message = error.message || "Falha ao executar requisição";
    }

    return Promise.reject(message);
  },
);

// ===================================
// 🔐 JWT Authorization
// ===================================
export const setAuthorization = (token: string | null) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

// ===================================
// 🧩 Função genérica apiCore<T>
// ===================================
export interface ApiCoreConfig {
  method?: "GET" | "POST" | "PUT" | "DELETE";
  body?: any;
  params?: Record<string, any>;
  headers?: Record<string, string>;
}

export const apiCore = async <T>(
  url: string,
  options: ApiCoreConfig = {},
): Promise<ApiResponse<T>> => {
  const { method = "GET", body, params } = options;

  const isFormData = body instanceof FormData;

  // const config: AxiosRequestConfig = {
  //   method,
  //   url,
  //   params,
  //   data: body,
  //   headers,
  // };

  const config: AxiosRequestConfig = {
    method,
    url,
    params,
    data: body,
    // headers: isFormData ? undefined : headers,
    headers: {
      // ...(headers ?? {}),
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
    },
  };

  const response = await axios.request<T>(config);
  return {
    data: response.data,
    status: response.status,
  };
};

// ===================================
// 👤 Usuário logado
// ===================================
export const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  return user ? JSON.parse(user) : null;
};
